import React, { Component } from 'react'
/**GRID COMPONENTS */
import JqxGrid, { jqx } from './jqwidgets-react/react_jqxgrid'
import JqxButton from './jqwidgets-react/react_jqxbuttons'
/*SEARCH COMPONENTS*/
import JqxInput from './jqwidgets-react/react_jqxinput'
import JqxToggleButton from './jqwidgets-react/react_jqxtogglebutton'
/**MODALS COMPONENTS */
import ModalPost from './modalPost'
import ModalPut from './modalPut'
import ModalDelete from './modalDelete'
/**EXPORT COMPONENTS */
import JqxDropDownButton from './jqwidgets-react/react_jqxdropdownbutton'
import JqxTree from './jqwidgets-react/react_jqxtree'
//CREATE MATERIAL-UI THEMES
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'

class CimGrid extends Component {

    constructor(props){
        super(props)
        //PROP OF MATERIAL-UI THEME
        this.theme = createMuiTheme(this.props.muiTheme);
        //ROW SELECTED
        this.row = null
        //ARRAY TO BUILD KEYS VALUE OF JSON TO BUILD PUT FORM
        this.keysPut = this.getKeysPut()
        //OBJECT TO SAVE RESPONSE OF fOREIGN KEY APIS
        this.fkEntity = {//OBJECT TO SAVE FETCH DATA OF FOREIGN KEYS
            'foreign_keys':[]
        }
        this.fk={//OBJECT TO SAVE FOREIGN KEY NAMES
            'name':[]
        }
        this.listDeleteIds = []//ARRAY TO SAVE IDS BUNDLE TO DELETE
        this.columnToSearch = null //SAVE COLUMN NAME FOR SEARCH
        //FIRST URL TO API AT THE FIRST GRID BUILD
        this.url = this.props.host+this.props.entity+'?page=0&pageSize=15'
        if(this.props.fkEntity){
            this.props.fkEntity.map((element)=>{
                this.fk.name.push({
                    'name':element.foreign
                })
            })
        }else{
            this.fk.name = null
        }
        this.flag = this.onClick.bind(this)//FLAG TO REFRESH GRID
        //CONFIGURATIONS FOR BUILD GRID COMPONENT
        var data= {
            datatype: 'xml',//DATATYPE TO RECIVE
            datafields: this.props.datafields,//DATAFIELDS TO RECIVE
            root: this.props.root,//ROOT FIELD
            record: this.props.record,//RECODR FIELD
            id: this.props.id,//ID FIELD
            url: this.url
            }
        //STATE OF PARENT COMPONENT
        this.state = {
            rowData: null,//DATA OF ROW SELECTED
            disabled: true,//DISABLED COMPONENTS
            page: 0,//GRID PAGE
            columns: this.props.columns,//GRID COLUMNS
            source: new jqx.dataAdapter(data),//GRID RESOURCE
            width: '100%',//GRID WIDTH TO MAKE RESPONSIVE
            rowsToShow: 15,//ROWS TO SHOW IN THE GRID
            fkEntity: null,//DATA OF FOREIGN KEYS API REPONSE
            globalUrl: this.props.host+this.props.entity+'?', //GLOBAL URL FOR MANAGMENT EVERY CHANGE
            flag: false, //FLAG TO REFRESH GRID
            flagExport:'',
            rowsSelected: [], //ARRAY TO SAVE ROWS SELECTED
            indexSelected: null //VALUE OF INDEX ROW SELECTED IN GRID
        }
    }

    buildSearchUrl(column, value){//VALUE TO SEARCH
        //NEW URL FOR SEARCH API
        var url = this.state.globalUrl//'cropId=0&requestStatusId=0&serviceId=0&vendorId=0&requestTypeId=0&page=0&pageSize=15'
        //BUILD NEW VALUES TO SEARCH IN API
        this.props.datafields.map((element)=>{
           if(element.name.toUpperCase()==column){//FIND COLUMN TO SEARCH
               url += 'column='+element.name+'&value='+value+'&'//BUILD NEW URL WITH VALUE IN COLUMN TO SEARCH
           }
        })
        // url = url.slice(url,url.length-1)//DELETE LAST CHARACTER IN API
        this.setState({
            globalUrl: url, //CHANGE GLOBAL URL
            page: 0 //RESET PAGE NUMBER
        })
        url += 'page='+this.state.page+'&pageSize='+this.state.rowsToShow
        console.log(url)
        return url//RETURN NEW API FOR SEARCH
    }

    getfetch(entity, callBack){//FETCH TO GET fOREIGN KEY VALUES
        var headers = new Headers()//HEADERS FOR FETCH
        let url = this.props.host+entity//BUILD FETCH API
        headers.append('Accept','application/json')//ADD HEADERS TO MAKE REQUEST
        var init = { method: 'GET',
                  headers: headers
                    };
        fetch(url, init)
        .then(function(response) {
            if(response.ok){
                return response.json()//MAKE RESPONSE TO JSON DATA
            }
        })
        .then(function(json){
            callBack (json)//RETURN JSON DATA
        })
        .catch(function(error){
            console.log(error)//SHOW ERROR DETAILS IN CONSOLE
        })
    }
    //LABELS TO PUT IN JSON BODY REQUEST
    getKeysPut(){
        var label = {
            'key':[]
          }
        this.props.datafields.map((element)=>{
            label.key.push({
                'name':element.name
            })
        })
        return label.key 
    }

    //GET LIST BUNDLE DELETE
    getListDelete(){
        this.listDeleteIds = []
        for( let i=0; i<this.state.rowsSelected.length; i++){
             let rowData = this.refs.Grid.getrowdata(i)//GET ROW DATA IN GRID
            this.listDeleteIds.push(rowData[this.props.id])
        }
        return this.listDeleteIds
    }

    //COMPONENT DID MOUNT LIFE CICLE REACT
    componentDidMount() {
        //EVENT TO BUILD SEARCH API
        this.refs.searchButton.on('click', ()=>{
            var value = this.refs.searchInput.val()
            this.buildSearchUrl(this.columnToSearch, value)

        })
            /**FETCH TO GET IDS */
            if(this.props.fkEntity!=null){
            this.props.fkEntity.map((element)=>{//GET EVERY FOREIGN KEY DATA
                if(element.entity!='' && element.entity!=null){
                this.getfetch(element.entity, res => { //SEND FETCH FOR EVERY FOREIGN KEY
                    this.fkEntity.foreign_keys.push(res) //ADD DATA RESULT FOR EVERY FOREIGN KEY
                    this.setState({ //ADD OBJECT RESULT TO STATE
                        fkEntity: this.fkEntity.foreign_keys
                        })
                    })
                }
            })
        }

        this.refs.Grid.on('rowselect', ()=>{//EVENT TRIGGER TO SET DATA IN PUT & DELETE COMPONENTS
            this.setState({
                rowsSelected: this.refs.Grid.getselectedrowindexes()//GET ARRAY OF ROWS SELECTED
            })
            this.setState({
                indexSelected: this.state.rowsSelected[this.state.rowsSelected.length - 1]// SET DEFAULT ROW SELECTED
            })
            this.rowData = this.refs.Grid.getrowdata(this.state.rowsSelected[this.state.rowsSelected.length - 1])//GET ROW DATA IN GRID
            var putData = {}//OBJECT TO SAVE ROW DATA
            this.keysPut.map((element)=>{
                putData[element.name] = this.rowData[element.name]//GET EVERY ROW CELL DATA
            })
            this.setState({
                rowData: putData,//UPDATE ROW DATA IN STATE
            })
        })

        this.refs.Grid.on('rowunselect', ()=>{//EVENT TRIGGER TO UPDATE DATA IN PUT & DELETE COMPONENTS
            this.setState({
                indexSelected: this.state.rowsSelected[this.state.rowsSelected.length - 1]//SET DEFAULT ROW SELECTED
            })
            this.setState({
                rowsSelected: this.refs.Grid.getselectedrowindexes()//GET ARRAY OF ROWS SELECTED
            })
            if(this.state.indexSelected === undefined){//SET NULL VALUE IN ROWDATA
                this.setState({
                    rowData: null,
                })
            }else{
                this.rowData = this.refs.Grid.getrowdata(this.state.rowsSelected[this.state.rowsSelected.length - 1])//GET ROW DATA IN GRID
                this.setState({
                    rowData: this.rowData,
                })
            }
        })

        this.refs.prevPage.on('click', ()=>{//EVENT TO UPDATE PAGE AND REFRESH NEW DATA IN GRID
            if(this.state.page < 1){
                this.refs.prevPage.setOptions({ disabled: true })//ENABLE PREV-BUTTON IN GRID
                return null
            }else{
                this.refs.prevPage.setOptions({ disabled: false })//DISABLE NEXT-BUTTON IN GRID
            var data={//NEW CONFIGURATION TO UPDATE DATA GRID
                datatype: 'xml',
                datafields: this.props.datafields,
                root: this.props.root,
                record: this.props.record,
                id: this.props.id,
                url: this.state.globalUrl+'page='+(this.state.page-1)+'&pageSize='+this.state.rowsToShow
                }
            var source= new jqx.dataAdapter(data)
            this.setState({
                page: this.state.page - 1,//CHANGE PAGE NUMBER
            }, ()=>{
                this.refs.Grid.source = null//CLEAR GRID DATA
                this.refs.Grid.setOptions({ source: source})//SET NEW CONFIGURATIONS FOR GRID
                this.refs.Grid.render()//REFRESH GRID
            })
        }
        })

        this.refs.nextPage.on('click', ()=>{//EVENT TO UPDATE PAGE AND REFRESH NEW DATA IN GRID
            this.refs.prevPage.setOptions({ disabled: false })//DISABLE PREV-BUTTON IN GRID
            this.refs.nextPage.setOptions({ disabled: true })//DISABLE NEXT-BUTTON IN GRID
            var data={//NEW CONFIGURATION TO UPDATE DATA GRID
                datatype: 'xml',
                datafields: this.props.datafields,
                root: this.props.root,
                record: this.props.record,
                id: this.props.id,
                url: this.state.globalUrl+'page='+(this.state.page+1)+'&pageSize='+this.state.rowsToShow
                }
            var source= new jqx.dataAdapter(data)
            this.setState({
                page: this.state.page + 1,//CHANGE PAGE NUMBER
            }, ()=>{
                this.refs.Grid.source = null //CLEAR DATA GRID
                this.refs.Grid.setOptions({ source: source}) //SET NEW CONFIGURATIONS FOR GRID
                this.activarButton() //ACTIVATE PREV BUTTON
            })
        })

        this.refs.exportTo.setContent('<div style="position: relative; margin-left: 3px; margin-top: 7px;">Export to...</div>')//EVENT TO EXPORT DATA GRID
        this.refs.treeExports.on('select',(event)=>{
            const item = this.refs.treeExports.getItem(event.args.element);
            this.refs.exportTo.close()
            switch(item.label){
                case 'PDF':
                    this.refs.Grid.exportdata('pdf', this.props.record)//EXPORT GRID TO PDF
                    break
                case 'CSV':
                    this.refs.Grid.exportdata('csv', this.props.record)//EXPORT GRID TO CSV
                    break
                case 'EXCEL':
                    this.refs.Grid.exportdata('xls', this.props.record)//EXPORT GRID TO XLS
                    break
                case 'JSON':
                    this.refs.Grid.exportdata('json', this.props.record)//EXPORT GRID TO JSON
                    break
            }
        })

        this.refs.rowsToShow.setContent('<div style="position: relative; margin-left: 3px; margin-top: 4px;">15</div>')//EVENT TO UPDATE ROWS TO SHOW IN GRID
        this.refs.treeRows.on('select',(event)=>{
            const item = this.refs.treeRows.getItem(event.args.element);
            this.refs.rowsToShow.setContent('<div style="position: relative; margin-left: 3px; margin-top: 4px;">'+item.label+'</div>')            
            this.refs.rowsToShow.close()
            this.setState({
                rowsToShow: item.label//UPDATE ROWS TO SHOW IN STATE
            })
            var data={//NEW CONFIGURATIONS TO UPDATE DATA GRID
                datatype: 'xml',
                datafields: this.props.datafields,
                root: this.props.root,
                record: this.props.record,
                id: this.props.id,
                url: this.state.globalUrl+'page='+(this.state.page)+'&pageSize='+this.state.rowsToShow
                }
            var source= new jqx.dataAdapter(data)
            this.refs.Grid.setOptions({ source: source})//UPDATE DATA GRID WITH NEW CONFRIGURATIONS
        })
        this.refs.columnToSearch.setContent('<div style="position: relative; margin-left: 3px; margin-top: 4px;">Select column...</div>')//EVENT TO SELECT A COLUMN TO SEARCH
        this.refs.treeColumnsToSearch.on('select',(event)=>{
            const item = this.refs.treeColumnsToSearch.getItem(event.args.element);
            this.columnToSearch = item.label;
            this.refs.columnToSearch.setContent('<div style="position: relative; margin-left: 3px; margin-top: 4px;">'+item.label+'</div>')            
            this.refs.columnToSearch.close()
        })
    }

        //ENABLE BUTTON
    activarButton(){
        this.refs.nextPage.setOptions({ disabled:false }) //ENABLE NEXT-BUTTON IN GRID
    }
    
        // LABELS FOR FORM
    getLabel(label){
        return label.toUpperCase()
    }

        //BUILD COLUMNS LIST OF LIST TO SEARCH
    buildListColumns(label){
        return <li key={'list'+label}>{this.getLabel(label)}</li>
    }

    onClick(flag){//FUNCTION TO REFRESH GRID
        if(flag!=undefined && this.state.flag!=flag){
            var data={//NEW CONFIGURATIONS TO UPDATE DATA GRID
                datatype: 'xml',
                datafields: this.props.datafields,
                root: this.props.root,
                record: this.props.record,
                id: this.props.id,
                url: this.state.globalUrl+'page='+(this.state.page)+'&pageSize='+this.state.rowsToShow
                }
            var source= new jqx.dataAdapter(data)
            this.refs.Grid.setOptions({ source: source})//UPDATE DATA GRID WITH NEW CONFRIGURATIONS
            this.setState({
                rowsSelected: [],//GET ARRAY OF ROWS SELECTED
                indexSelected:null,
                rowData:null
            })
        }
    }
    
    render() {
        return (
            <React.Fragment>
                <React.Fragment>
                    <table
                    width={this.state.width}>
                        <tbody >
                            <tr>
                                <td>
                                    {/* CATALOG TITLE */}
                                    <label 
                                    className={'ebs-label'}
                                    >
                                    {this.getLabel(this.props.record)}
                                    </label>
                                    </td>
                                    <td>
                                        <table align={'right'}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {/* SELECT COLUMN TO SEARCH COMPONENT */}
                                                        <React.Fragment>
                                                            <JqxDropDownButton //COMBO BOX
                                                                ref={'columnToSearch'} 
                                                                theme={this.props.theme}
                                                                width={150} 
                                                                height={25} 
                                                                autoOpen={this.state.autoOpen}
                                                            >
                                                            <JqxTree //OPTIONS IN COMBO BOX
                                                                ref={'treeColumnsToSearch'} 
                                                                width={150} 
                                                                theme={this.props.theme}
                                                            >
                                                                <ul> {/* OPTIONS LIST IN COMBO BOX */}
                                                                {this.props.datafields.map((element)=>
                                                                    this.buildListColumns(element.name)
                                                                )}
                                                                </ul>
                                                            </JqxTree>
                                                            </JqxDropDownButton>
                                                        </React.Fragment>
                                                    </td>
                                                    <td>
                                                        {/* SEARCH INPUT COMPONENT */}
                                                        <JqxInput  
                                                            ref={'searchInput'} 
                                                            width={200} 
                                                            theme={this.props.theme}
                                                            height={25} 
                                                            placeHolder={'Search all about...'}
                                                        />
                                                    </td>
                                                    <td>
                                                        {/* SEARCH BUTTON COMPONENT */}
                                                        <JqxToggleButton 
                                                            ref={'searchButton'} 
                                                            className="togglebutton"
                                                            width={50}
                                                            height={25}
                                                            value={'search'}
                                                            theme={this.props.theme}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                <td>
                                    <table
                                    align={'right'}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    {/* EXPORT COMPONENTS */}
                                                    <React.Fragment>
                                                        <JqxDropDownButton //COMBO BOX
                                                            ref={'exportTo'} 
                                                            theme={this.props.theme}
                                                            width={100} 
                                                            height={30} 
                                                            autoOpen={this.state.autoOpen}
                                                        >
                                                            <JqxTree //OPTIONS IN COMBO BOX
                                                                ref={'treeExports'} 
                                                                width={100} 
                                                                theme={this.props.theme}
                                                            >
                                                                <ul> {/* OPTIONS LIST IN COMBO BOX */}
                                                                    <li>PDF</li>
                                                                    <li>CSV</li>
                                                                    <li>EXCEL</li>
                                                                    <li>JSON</li>
                                                                </ul>
                                                            </JqxTree>
                                                        </JqxDropDownButton>
                                                    </React.Fragment>
                                                </td>
                                                <td>
                                                    {/* DELETE COMPONENT */}
                                                <MuiThemeProvider theme={this.theme}>
                                                    <ModalDelete
                                                        onClick={this.flag}//FLAG TO REFRESH GRID                                                   
                                                        id={this.props.id}//ID ROW
                                                        listDeleteIds={this.getListDelete()}//IDS LIST TO DELETE
                                                        record={this.props.root}//RECORD
                                                        rowData={this.state.rowData}//ROW DATA
                                                        data={this.props.datafields}//DATAFIELDS
                                                        host={this.props.host}//HOST
                                                        entity={this.props.entity}//ENTITY
                                                        flag={this.state.flag}//FLAG TO REFRESH GRID
                                                    ></ModalDelete>
                                                </MuiThemeProvider>
                                                </td>
                                                <td>
                                                    {/* UPDATE COMPONENT */}
                                                <MuiThemeProvider theme={this.theme}>
                                                    <ModalPut
                                                        onClick={this.flag}//FLAG TO REFRESH GRID                                         
                                                        fk={this.fk.name}//ARRAY FOREIGN KEYS NAMES
                                                        fkEntity={null}//OBJECT FOREIGN KEYS DATA
                                                        id={this.props.id}//ID ROW
                                                        record={this.props.root}//RECORD
                                                        rowData={this.state.rowData}//ROW DATA
                                                        data={this.props.datafields}//DATAFIELDS
                                                        host={this.props.host}//HOST
                                                        entity={this.props.entity}//ENTITY
                                                        flag={this.state.flag}//FLAG TO REFRESH GRID
                                                    ></ModalPut>
                                                </MuiThemeProvider>
                                                </td>
                                                <td>
                                                    {/* ADD COMPONENT */}
                                                <MuiThemeProvider theme={this.theme}>
                                                    <ModalPost 
                                                        onClick={this.flag}//FLAG TO REFRESH GRID
                                                        fk={this.fk.name}//ARRAY FOREIGN KEYS NAMES
                                                        fkEntity={this.state.fkEntity}//OBJECT FOREIGN KEYS DATA
                                                        data={this.props.datafields}//DATAFIELDS
                                                        host={this.props.host}//HOST
                                                        entity={this.props.entity}//ENTITY
                                                        record={this.props.record}//RECORD
                                                        flag={this.state.flag}//FLAG TO REFRESH GRID
                                                    ></ModalPost>
                                                </MuiThemeProvider>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </React.Fragment>
                <React.Fragment>
                    {/* GRID AND CONSFIGURATIONS */}
                    <JqxGrid ref={'Grid'}
                        height={450}//HEIGHT IN GRID
                        keyboardnavigation={true}//ENABLE KEYBOARD NAVIGATION
                        source={this.state.source} //SOURCE FOR LOAD GRID DATA
                        columns={this.state.columns} //COLUMNS TO SHOW IN GRID
                        columnsresize={true} //RESIZE COLUMNS WIDTH
                        autoheight={true} //ENABLE AUTO HEIGHT
                        sortable={true} //ENABLE SHORT
                        adaptivewidth={true} //ENABLE ADAPTATIVE WIDTH
                        selectionmode={'checkbox'} //CHECKBOX ROWS SELECTION
                        pagesize={this.state.rowsToShow} //ROWS TO SHOW IN PAGE
                        altrows={true} //ENABLES OR DISABLES THE ALTERNATING ROWS
                        enabletooltips={true} //ENABLE GRID TOOLTIPS
                        showheader={true} //SHOW GRID HEADER
                        autoshowcolumnsmenubutton={false} //SHOW MENU GRID IN HEADER ALWAYS
                        filterable={true} //SHOW FILTER IN MENU GRID
                        autoshowfiltericon={true} //SHOW ICON FILTER
                        theme={this.props.theme} //THEME IN GRID
                        width={this.state.width} //ENABLE RESPONSIVE GRID BY STATE
                    ></JqxGrid>
                </React.Fragment>
                {/* FOOTHER IN GRID */}
                <React.Fragment>
                    <table 
                        width={this.state.width} //ENABLE RESPONSIVE WIDTH BY STATE
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <table>
                                        <tbody>
                                            <tr 
                                                align={'left'} 
                                            >
                                                <td>
                                                <React.Fragment>
                                                    {/* ROWS TO SHOW COMPONENTS */}
                                                    <JqxDropDownButton 
                                                        ref={'rowsToShow'} 
                                                        theme={this.props.theme} //THEME
                                                        width={70} 
                                                        height={25} 
                                                        autoOpen={this.state.autoOpen}
                                                    >
                                                        <JqxTree //ROWS OPTIONS TO SHOW
                                                            ref={'treeRows'} 
                                                            width={70} 
                                                            theme={this.props.theme}
                                                        >
                                                            {/* LIST OPTIONS */}
                                                            <ul>
                                                                <li>15</li>
                                                                <li>20</li>
                                                                <li>30</li>
                                                                <li>50</li>
                                                            </ul>
                                                        </JqxTree>
                                                    </JqxDropDownButton>
                                                </React.Fragment>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td 
                                    align={'right'}
                                >
                                    <table>
                                        <tbody>
                                            <tr 
                                                align={'right'} 
                                            >
                                                <td>
                                                    {/* PREV-BUTTON COMPONENT */}
                                                    <JqxButton 
                                                        disabled={true} 
                                                        ref='prevPage' 
                                                        height={30} 
                                                        width={55} 
                                                        template={'link'}
                                                        theme={this.props.theme}
                                                    >{'<'}
                                                    </JqxButton>
                                                </td>
                                                <td>
                                                    {/* THIS COMPONENT WILL BE CHANGE FOR AN INPUT COMPONENT */}
                                                    <label 
                                                        className={'ebs-label'}
                                                    >
                                                    {this.state.page+1}
                                                    </label>
                                                </td>
                                                <td>
                                                    {/* NEXT-BUTTON COMPONENT */}
                                                    <JqxButton 
                                                        ref='nextPage' 
                                                        height={30} 
                                                        width={55} 
                                                        template={'link'} 
                                                        theme={this.props.theme}
                                                    >{'>'}
                                                    </JqxButton>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </React.Fragment>
            </React.Fragment>
        )
    }
}
export default CimGrid;